import { LocalizedEnum } from "../../../../../../modules/localization/components/AppLocalized"
import React, { useState } from "react"
import { IconButton, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import RemoveIcon from "@mui/icons-material/Remove"
import AddIcon from "@mui/icons-material/Add"

type PlusMinusButtonFilterProps = {
    value: null | number
    identifier: string
    setValue: (value: number | null) => void
}

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "1rem",
    },
    input: {
        textAlign: "center",
        lineHeight: "2.5",
        width: "4rem",
        height: "2.5rem",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: ".5rem",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        fontSize: "1rem",
        outline: "none",
    },
    button: {
        width: "2.5rem",
        height: "2.5rem",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: ".5rem",
    },
}))

const MAX_SEAT_COUNT = 9999

export function PlusMinusButtonFilter({ value, setValue, identifier }: PlusMinusButtonFilterProps) {
    const { classes } = useStyles()
    const [seatCount, setSeatCount] = useState(value ?? 0)

    const handleIncrease = () => {
        setSeatCount((prev) => prev + 1)
        setValue(seatCount + 1)
    }

    const handleDecrease = () => {
        if (seatCount > 1) {
            setSeatCount((prev) => prev - 1)
            setValue(seatCount - 1)
        }
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value
        const numericValue = parseInt(inputValue, 10)

        if (inputValue === "") {
            setSeatCount(0)
            setValue(null)
        } else if (!isNaN(numericValue) && numericValue >= 0) {
            const limitedValue = numericValue > MAX_SEAT_COUNT ? MAX_SEAT_COUNT : numericValue
            setSeatCount(limitedValue)
            setValue(limitedValue)
        }
    }

    return (
        <Stack direction="column" padding=".5rem 1rem" spacing="1rem">
            <LocalizedEnum base="resource-booking-chip-filter-select-title" enumValue={identifier}>
                <Typography fontWeight={600} marginBottom=".5rem">
                    Select
                </Typography>
            </LocalizedEnum>
            <Stack direction="row" spacing=".5rem">
                <IconButton className={classes.button} onClick={handleDecrease} size="small">
                    <RemoveIcon fontSize="small" />
                </IconButton>
                <input
                    type="tel"
                    value={seatCount === 0 && value === null ? "" : seatCount}
                    onChange={handleInputChange}
                    className={classes.input}
                    min="1"
                    maxLength={4}
                />
                <IconButton className={classes.button} onClick={handleIncrease} size="small">
                    <AddIcon fontSize="small" />
                </IconButton>
            </Stack>
        </Stack>
    )
}
